export const convertTimeSeconds = (timer) => {
    if (timer === 0 || timer === null) {
        return '0:00';
    }
    const hours = Math.floor(timer / 3600);
    const minutes = Math.floor((timer - hours * 3600) / 60);
    const seconds = timer - hours * 3600 - minutes * 60;
    return hours
        ? hours + ' horas ' + minutes + ' minutos ' + seconds + ' segundos '
        : minutes + ' minutos ' + seconds + ' segundos';
};
